export default __webpack_public_path__ + "static/media/icon-done.cea7a763.svg";